import { useEffect, useRef, useState } from 'react'
import { checkEmptyValue } from '../../../../plugins/common'

const ListTable = ({ selectable, headerColumns, data, handledbClick }) => {
    const containerRef = useRef(null)
    const [visibleRows, setVisibleRows] = useState(0)
    const [selected, setSelected] = useState(null)

    const emptyRowsCount = Math.max(0, visibleRows - (data?.length || 0))

    const handleSelect = (rowIdx) => {
        if (!selectable) return
        // Handle row selection logic here
        setSelected(rowIdx)
    }
    useEffect(() => {
        setSelected(null)
    }, [headerColumns])

    useEffect(() => {
        const updateVisibleRows = () => {
            if (containerRef.current) {
                const containerHeight = containerRef.current.clientHeight
                const rowHeight = 31 // 30px + 1px gap
                const maxRows = Math.floor(containerHeight / rowHeight)
                setVisibleRows(maxRows)
            }
        }

        updateVisibleRows()
    }, [])

    return (
        <div className="w-full h-full scrollbar scrollbar--gray relative"  style={{ 
            paddingRight: emptyRowsCount > 0 ? 0 : 4,
            overflowY: emptyRowsCount > 0 ? 'hidden' : 'auto',
            overflowX: 'auto',
        }}>
            <div className="sticky top-0 z-10 flex h-[30px] gap-[1px] w-full">
                {
                    headerColumns.map((item, idx) => {
                        return (
                            <div 
                                key={`list-table-header-${idx}`}
                                className="flex items-center justify-center font-light bg-[#262626]"
                                style={{
                                    borderTopLeftRadius: idx === 0 ? '6px' : '',
                                    borderTopRightRadius: idx === headerColumns.length - 1 ? '6px' : '',
                                    minWidth: item.width,
                                    maxWidth: item.width,
                                    color: '#CECECE'
                                }}
                            >
                                { item.label }                       
                            </div>
                        )
                    })
                }
            </div>
            <div ref={containerRef} className="flex" style={{ height: 'calc(100% - 30px)' }}>
                <div 
                    className={`h-full flex flex-col gap-[1px] bg-gray-300`}
                    style={{ 
                        width: '100%',
                    }}>
                    {
                        data?.map((row, rowIdx) => (
                            <div 
                                onClick={() => { handleSelect(rowIdx) }}
                                onDoubleClick={() => { selectable && handledbClick(row) }}
                                key={`list-table-row-${rowIdx}`}
                                className={`flex gap-[1px] h-[30px] bg-gray-300 ${selectable ? 'group cursor-pointer' : ''} `}
                                style={{
                                    ...(selected === rowIdx && {
                                        background: 'linear-gradient(180deg, #3182F7 0%, #1562D1 100%)'
                                    })
                                }}
                            >
                                {
                                    headerColumns.map((column, colIdx) => (
                                        <div
                                            key={`list-table-cell-${rowIdx}-${colIdx}`}
                                            className={`flex items-center font-light ${
                                                selected === rowIdx 
                                                    ? 'bg-transparent text-white' 
                                                    : selectable 
                                                        ? 'bg-white group-hover:bg-[rgba(49,130,247,0.2)]' 
                                                        : 'bg-white'
                                            }`}
                                            style={{
                                                justifyContent: column.key === 'no' ? 'center' : 'flex-start',
                                                minWidth: column.width,
                                                maxWidth: column.width,
                                                padding: '8px 4px',
                                                ...(selected === rowIdx && {
                                                    background: 'linear-gradient(180deg, #3182F7 0%, #1562D1 100%)'
                                                })
                                            }}
                                        >                                            
                                            {                                                
                                                // Temp인 경우 소수점 한자리까지만 표기 할 수 있게 수정.
                                                column.key.includes('temperatureCelsius') ? (row[column.key] != null ? (Math.floor(row[column.key] * 10) / 10).toFixed(1) : '-') : checkEmptyValue(row[column.key])
                                            }
                                            {
                                                column.hasAction && row.stoppable &&
                                                <div onClick={() => { column.handleAction(row) }} className="ml-auto flex justify-center items-center cursor-pointer w-[60px] h-[28px] bg-gradient-to-b from-[#FFFFFF] to-[#DEDEDE] rounded-[6px] font-light" style={{ fontSize: 16, border: '1px solid', borderImageSource: 'linear-gradient(180deg, #B8B8B8 0%, #B0B0B0 100%)' }}>
                                                {column.actionText}</div>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    }
                    {
                        Array.from({ length: emptyRowsCount !== 0 ? emptyRowsCount + 1 : 0 }).map((_, emptyRowIdx) => (
                            <div key={`empty-row-${emptyRowIdx}`} className="flex gap-[1px] min-h-[30px]">
                                {
                                    headerColumns.map((column, colIdx) => (
                                        <div
                                            key={`empty-cell-${emptyRowIdx}-${colIdx}`}
                                            className="bg-white"
                                            style={{
                                                minWidth: column.width,
                                                maxWidth: column.width,
                                                height: '30px'
                                            }}
                                        >
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )

}

export default ListTable